import React from 'react';
import PropTypes from 'prop-types';
import { th, variants } from 'style/theme';
import { sizes } from 'style';
import styled, { css } from 'styled-components';
import LoadingOverlay from 'components/LoadingOverlay';

const StyledCard = styled.div`
  ${variants('variant', {
    light: css`
      color: ${th('colors.black')};
      background-color: ${(props) => th(`colors.${props.bg || 'white'}`)};
    `,
    dark: css`
      color: ${th('colors.white')};
      background-color: ${(props) => th(`colors.${props.bg || 'black'}`)};
    `,
    global: css`
      color: ${th('colors.white')};
      background-color: ${(props) => th(`colors.${props.bg || 'black'}`)};
    `
  })};

  ${variants('size', {
    regular: css`
      padding: 20px;
      border-radius: 10px;
      @media ${sizes.mobileLarge} {
        padding: 36px;
      }
    `,
    thin: css`
      padding: 24px;
      border-radius: 8px;
    `
  })}

  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: ${th('shadows.small')};

  ${(props) =>
    props.isLoading &&
    css`
      & > * {
        filter: blur(3.5px);
      }
    `}
`;

const Card = ({ children, variant, size, isLoading, className }) => {
  return (
    <StyledCard isLoading={isLoading} variant={variant} size={size} className={className}>
      <LoadingOverlay isLoading={isLoading} variant={variant} />
      {children}
    </StyledCard>
  );
};

Card.defaultProps = {
  variant: 'light',
  size: 'regular'
};

Card.propTypes = {
  children: PropTypes.any,
  variant: PropTypes.oneOf(['light', 'dark', 'global']),
  size: PropTypes.string,
  isLoading: PropTypes.bool,
  className: PropTypes.string
};

export default Card;
